import styled from 'styled-components';

export const Container = styled.div`
  .MuiFormLabel-root {
    margin-bottom: 10px;
  }

  .MuiChip-label {
    white-space: pre-wrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
`;
